import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-pause-candidate-exam',
  templateUrl: './pause-candidate-exam.component.html',
  styleUrls: ['./pause-candidate-exam.component.scss']
})
export class PauseCandidateExamComponent implements OnInit {

  constructor(private popoverRef: PopoverRef<any>, private examSchService: ExamScheduleService, private examService: ExamService, private snackBar: SnackbarService,) { }
  paused: boolean = false;
  allowProctorUndo: boolean = false;
  ngOnInit(): void {
    this.paused = this.examSchService.selectedSchedules[0].examPaused;
  }

  close() {
    this.popoverRef.close();
  }

  async yesClicked() {

    let data = {
      Ids: this.examSchService.selectedIds.map(x => parseInt(x)),
      SelectAll: this.examSchService.selectAll,
      Pause: this.paused,
      AllowProctorUndo: this.allowProctorUndo,
      ExaminationID: this.examService.selectedExamIds[0],
    }
    const res = await this.examSchService.pauseCandidate(data) as any[];
    if (res !== null && res.length > 0) {
      res.forEach(e => {
        this.snackBar.error(e);
      })
    }
    else {
      this.snackBar.success('Candidate Exam Paused Successfully!');
    }
    this.examSchService.reloadGrid.next(true);
    this.close();
  }

  noClicked() {
    this.close();
  }

  onChange(event) {

    this.allowProctorUndo = event.target.checked as boolean;
  }

}
